'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsonStableStringify = require('json-stable-stringify');

var _jsonStableStringify2 = _interopRequireDefault(_jsonStableStringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestQueue = function () {

    // Queue of requests awaiting dispatch
    function RequestQueue() {
        var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _axios2.default;
        (0, _classCallCheck3.default)(this, RequestQueue);
        this.dispatchQueue = [];
        this.activeRequests = new _map2.default();

        this.client = client;
    }

    /**
     * Adds a request to the RequestQueue. Returns a promise that is resolved or rejected when
     * the request completes.
     * @param config
     * @returns {Promise}
     */


    // Map of all pending requests


    (0, _createClass3.default)(RequestQueue, [{
        key: 'add',
        value: function add(config) {
            var _this = this;

            var request = {
                url: config.url,
                success: function success() {},
                error: function error() {}
            };

            // Note: To pass type checking, manual assignment of maybe types is required. See https://github.com/facebook/flow/issues/2167
            if (config.data) request.data = config.data;
            if (config.method) request.method = config.method;
            if (config.auth) request.auth = config.auth;
            if (config.progress) request.progress = config.progress;
            if (config.maxContentLength) request.maxContentLength = config.maxContentLength;
            if (config.maxRedirects) request.maxRedirects = config.maxRedirects;
            if (config.headers) request.headers = config.headers;
            if (config.params) request.params = config.params;
            if (config.paramsSerializer) request.paramsSerializer = config.paramsSerializer;
            if (config.responseType) request.responseType = config.responseType;
            if (config.transformResponse) request.transformResponse = config.transformResponse;
            if (config.transformRequest) request.transformRequest = config.transformRequest;
            if (config.timeout) request.timeout = config.timeout;
            if (config.validateStatus) request.validateStatus = config.validateStatus;
            if (config.withCredentials) request.withCredentials = config.withCredentials;
            if (config.xsrfCookieName) request.xsrfCookieName = config.xsrfCookieName;
            if (config.xsrfHeaderName) request.xsrfHeaderName = config.xsrfHeaderName;
            if (config.httpAgent) request.httpAgent = config.httpAgent;
            if (config.httpsAgent) request.httpsAgent = config.httpsAgent;

            var key = (0, _jsonStableStringify2.default)(request);

            if (this.activeRequests.has(key)) {
                var record = this.activeRequests.get(key);
                if (record) {
                    return record.promise;
                }
            }

            // Create a promise that we can return immediately. Since the dispatch happens
            // asynchronously, we won't have the axios promise to return.
            var promise = new _promise2.default(function (resolve, reject) {
                // Attach the resolve and reject functions to the request so that
                // we can fulfill/reject the promise when the request completes.
                request.success = resolve;
                request.error = reject;
            });

            this.activeRequests.set(key, { request: request, promise: promise });

            this.dispatchQueue.push(request);
            if (this.dispatchQueue.length === 1) {
                setTimeout(function () {
                    return _this.checkQueue();
                }, 1);
            }

            return promise;
        }
    }, {
        key: 'checkQueue',
        value: function checkQueue() {
            var _this2 = this;

            if (this.dispatchQueue.length > 0) {
                (function () {
                    var request = _this2.dispatchQueue.shift();
                    var promise = _this2.client(request);

                    // Add then/catch to the promise chain so that we can fulfill/reject
                    // the promise returned by RequestQueue.add().
                    promise.then(function () {
                        return request.success.apply(request, arguments);
                    }).catch(function () {
                        return request.error.apply(request, arguments);
                    }).then(function () {
                        var key = (0, _jsonStableStringify2.default)(request);
                        _this2.activeRequests.delete(key);
                    });

                    setTimeout(function () {
                        return _this2.checkQueue();
                    }, 1);
                })();
            }
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            // No API exists for cancelling active HTTP requests yet
            // See https://github.com/whatwg/fetch/issues/27 and https://github.com/mzabriskie/axios/issues/50
        }
    }, {
        key: 'cancelAll',
        value: function cancelAll() {
            // No API exists for cancelling active HTTP requests yet
            // See https://github.com/whatwg/fetch/issues/27 and https://github.com/mzabriskie/axios/issues/50
        }
    }]);
    return RequestQueue;
}();

exports.default = RequestQueue;
//# sourceMappingURL=requestQueue.js.map